module.exports = __webpack_public_path__ + "img/mm_logo.f16267de.png";